import type { GoodLuckCoreDTOsTournamentTeamDto } from "@/shared/api/generated-kubb/types/goodLuck/core/DTOs/TournamentTeamDto";

/**
 * Команда турнира с мостом к драфт-команде.
 *
 * `draftTeamId` отдаёт бэкенд (`TournamentService.GetTeamsAsync`), но в
 * kubb-типах его пока нет: они генерятся из спеки задеплоенного стенда. Поэтому
 * поле объявлено здесь, а не правкой `generated-kubb/**` — тот каталог
 * перезаписывается генератором.
 */
export type TournamentTeamWithDraftLink = GoodLuckCoreDTOsTournamentTeamDto & {
  draftTeamId?: string | null;
};

/**
 * Находит команду турнира по идентификатору команды из сетки.
 *
 * В классическом турнире сетка ссылается на тот же id, что и список команд.
 * В драфт-турнире сетка оперирует `DraftTeam.Id`, а состав и страница команды
 * живут по `Roster.Id` — сопоставить их можно только через `draftTeamId`.
 * По имени сопоставлять нельзя: ростер могли переименовать после драфта, и
 * в проде такие расхождения уже есть.
 */
export function findMatchTeam<T extends TournamentTeamWithDraftLink>(
  teams: readonly T[] | null | undefined,
  teamId: string | null | undefined,
): T | null {
  if (!teamId || !teams?.length) return null;
  return (
    teams.find((t) => t.id === teamId) ??
    teams.find((t) => t.draftTeamId === teamId) ??
    null
  );
}

/**
 * Ссылка на страницу команды. `null` — если команду не удалось сопоставить с
 * ростером: лучше некликабельное название, чем переход в 404.
 */
export function rosterHref(
  team: TournamentTeamWithDraftLink | null | undefined,
): string | null {
  return team?.id ? `/rosters/${encodeURIComponent(team.id)}` : null;
}
